import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalMessageType, InternalServerErrorHandler } from '@spartacus/core';
import { findLimitedAvailabilityCheckoutError, isLimitedAvailabilityCode, isLimitedAvailabilityStatus } from '../utils/limited-availability.utils';
import { GenNotification } from '../models/notification.model';

@Injectable({
  providedIn: 'root',
})
export class GenInternalServerErrorHandler extends InternalServerErrorHandler {
  override handleError(_request?: HttpRequest<any>, response?: HttpErrorResponse): void {
    if (
      findLimitedAvailabilityCheckoutError(response) ||
      response?.error?.message ||
      response?.error?.generacNotifications?.some(
        (n: GenNotification) =>
          isLimitedAvailabilityStatus(n.code) || isLimitedAvailabilityCode(n.code)
      )
    ) {
      return; // Don't show error message for limited availability 500 responses
    }

    this.globalMessageService.add(
      { key: 'httpHandlers.internalServerError' },
      GlobalMessageType.MSG_TYPE_ERROR
    );
  }
}
